import { DenormalizedCustomizableGroup, DenormalizedCustomizableQuestion } from '@packages/types'
import { useEffect, useRef } from 'react'

import { useSelector } from 'customizer/hooks'
import * as questionPanelSelectors from 'customizer/questionPanel/selectors'

export type useSummaryDrawerErrorScrollParams = {
  steps: (DenormalizedCustomizableGroup | DenormalizedCustomizableQuestion)[]
  selector?: string
}

const useSummaryDrawerErrorScroll = ({
  steps,
  selector = '.summary-drawer__step-error',
}: useSummaryDrawerErrorScrollParams) => {
  const showInteractionRequiredWarnings = useSelector(questionPanelSelectors.showInteractionRequiredWarningsSelector)
  const listRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (showInteractionRequiredWarnings) {
      setTimeout(() => listRef.current?.querySelector(selector)?.scrollIntoView({ behavior: 'smooth' }), 500)
    }
  }, [showInteractionRequiredWarnings, steps])

  return { ref: listRef }
}

export default useSummaryDrawerErrorScroll
